<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>Admin Portal</h1>
      <p>Sign in to access the admin dashboard</p>
    </div>
    
    <div class="login-content">
      <!-- Show message if user is already authenticated -->
      <div *ngIf="authService.currentUser" class="redirect-message">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>You are already signed in. Redirecting to dashboard...</p>

          <button 
            class="dashboard-btn" 
            (click)="redirectToDashboard()">
            Go to Dashboard
          </button> 
        </div>
      </div>
      
      <!-- FirebaseUI container - always present but hidden when authenticated -->
      <div 
        #firebaseUIContainer 
        [style.display]="authService.currentUser ? 'none' : 'block'">
      </div>
    </div>
    
    <div class="login-footer"  style="text-align: center; padding: 10px; background-color: #f1f1f1;">
      <p style="margin: 0;">Copyright &copy; DiGivCards.ai .</p>
    <p style="margin: 0;">All rights reserved. A Unit of Tamilarasi Technologies Private Limited.</p>
    </div>
  </div>
</div>
